import { Item as ItemWrapper, Row } from '@/src/components/Layouts';
import SectionWrapper from '@/src/components/Layouts/Section/SectionWrapper';
import Link from '@/src/components/Link/Link';
import React from 'react';
// import Input from '@/src/components/Antd/NumberInput/NumberInput';
import {
  Form,
  OriCheckbox,
  OriNumberInput,
  SizeFittingTable,
} from '@/src/components/Antd';
import { EditIcon } from '@/src/components/EditableTable/EditableTable';
import { get, isEqual, isNumber } from 'lodash';
import { TableNumberInputFormItemSupport } from 'src/components/EditableTable/TableForm1';
import GlobalTooltip, {
  NoWrapContainer,
} from 'src/components/GlobalTooltip/GlobalTooltip';
import { useI18n } from 'src/hooks/useRouterChange';
import Section from 'src/pages/SalesCannelVersion/Components/SectionContainer';
import { isInteger } from 'src/tools/helper';
import { i18nGet } from 'src/tools/tools';
import css from './css.module.less';

// import CustomCollapse from '@/src/components/Antd/SingleCollapse/Collapse';
// import EditableTable from '@/src/components/EditableTable/EditableTable';
// import TotalAndLeft from './TotalAndLeft';

// import { EnumProductType } from 'src/types/common/product';
// import Checkbox from '@/src/components/Antd/Checkbox/Checkbox';
// import { availableColumns } from './Columns';
const Item = Form.Item;
const List = Form.List;

const quantityFeatureName = 'salesChannelStockEnabled';
const oversellingQuotaName = 'oversellQuotaEnabled';
const totalStockName = 'stockAvailable';
const warehousePartBaseName = 'warehouseStocks';

const Stock = (props) => {
  const i18n = useI18n();
  const getI18n = (str) => i18nGet(i18n, str);
  const {
    //data = {},
    inventoryUuid,
    title,
    secondTitle,
    //warehouses = [],
    form,
    disabled,
  } = props;
  //const ref = React.useRef(null);
  // console.log('form', form);
  // // console.log('warehouses', warehouses);

  return (
    <SectionWrapper
      containerClassName={css.wrapper}
      title={title}
      subtitle={secondTitle}
      rightPart={
        inventoryUuid !== 'new' ? (
          <Link
            disable={!inventoryUuid}
            to={inventoryUuid ? `/allInventory/${inventoryUuid}` : '#'}
            className={`${css.tagsRightPart}`}>
            {getI18n('allProducts.addproductset.stock_component_viewhistory')}
          </Link>
        ) : null
      }>
      <Section bottomBorder>
        <div className={css.checkboxContainer}>
          <Item name={quantityFeatureName} valuePropName='checked'>
            <OriCheckbox disabled={disabled}>
              {getI18n(
                'allProducts.addproductset.stock_component_quantity_feature',
              )}
            </OriCheckbox>
          </Item>
          <div className={css.checkboxTips}>
            {getI18n('allProducts.addproductset.stock_component_assign_stock')}
          </div>
        </div>
        <div className={css.checkboxContainer}>
          <Item name={oversellingQuotaName} valuePropName='checked'>
            <OriCheckbox disabled={disabled}>
              {getI18n(
                'allProducts.addproductset.stock_component_overselling_quota',
              )}
            </OriCheckbox>
          </Item>
          <div className={css.checkboxTips}>
            {getI18n('allProducts.addproductset.stock_component_sold_inexcess')}
          </div>
        </div>
      </Section>
      <Section bottomBorder>
        <Item
          shouldUpdate={(p, c) => {
            const pv = get(p, oversellingQuotaName);
            const cv = get(c, oversellingQuotaName);
            return pv !== cv;
          }}>
          {({ getFieldValue }: any) => {
            const v = getFieldValue(oversellingQuotaName);
            return v ? (
              <Row
                elements={[
                  {
                    child: (
                      <ItemWrapper
                        title={getI18n('allProducts.addproductset.totalStock')}>
                        <Item
                          shouldUpdate={(p, c) => {
                            const pv = get(p, totalStockName);
                            const cv = get(c, totalStockName);
                            return pv !== cv;
                          }}>
                          {({ getFieldValue }: any) => {
                            const v = getFieldValue(totalStockName);
                            return v;
                          }}
                        </Item>
                      </ItemWrapper>
                    ),
                  },
                  {
                    child: (
                      <ItemWrapper
                        title={getI18n(
                          'allProducts.addproductset.totalOversellingQuota',
                        )}>
                        <Item shouldUpdate>
                          {({ getFieldValue }: any) => {
                            const pv =
                              getFieldValue(warehousePartBaseName) || [];
                            const pOversellingQuota = pv.reduce((t, p) => {
                              const n = get(p, 'oversellingQuota');
                              const num = isNumber(n) ? n : 0;
                              //console.log('n', n, t + n, t + isNumber(n) ? n : 0);
                              return t + num;
                            }, 0);
                            return pOversellingQuota;
                          }}
                        </Item>
                      </ItemWrapper>
                    ),
                  },
                ]}></Row>
            ) : (
              <Row
                elements={[
                  {
                    child: (
                      <ItemWrapper
                        title={getI18n('allProducts.addproductset.totalStock')}>
                        <Item
                          shouldUpdate={(p, c) => {
                            const pv = get(p, totalStockName);
                            const cv = get(c, totalStockName);
                            return pv !== cv;
                          }}>
                          {({ getFieldValue }: any) => {
                            const v = getFieldValue(totalStockName);
                            return v;
                          }}
                        </Item>
                      </ItemWrapper>
                    ),
                  },
                ]}></Row>
            );
          }}
        </Item>
      </Section>
      <List name={warehousePartBaseName}>
        {(fields, { add, move, remove }) => {
          return (
            <React.Fragment>
              {fields.map((item, index) => {
                const baseName = fields[index].name;
                const name = form.getFieldValue([
                  warehousePartBaseName,
                  index,
                  'warehouseName',
                ]);
                //console.log('name', name);
                const warehouseStock =
                  form.getFieldValue([
                    warehousePartBaseName,
                    index,
                    'warehouseStock',
                  ]) || 0;
                const tableName = [baseName, 'salesChannelItems'];
                return (
                  <Section bottomBorder key={index}>
                    <div className={css.warehouseName}>{name}</div>
                    <Item
                      noStyle
                      shouldUpdate={(p, c) => {
                        const pQ = get(p, oversellingQuotaName);
                        const cQ = get(c, oversellingQuotaName);

                        return pQ !== cQ;
                      }}>
                      {({ getFieldValue }: any) => {
                        const overSellingQuota =
                          getFieldValue(oversellingQuotaName);

                        if (overSellingQuota) {
                          return (
                            <Row
                              elements={[
                                {
                                  // name={[...baseName, 'oversellingQuota']}
                                  child: (
                                    <ItemWrapper
                                      title={getI18n(
                                        'allProducts.addproductset.oversellingQuota',
                                      )}>
                                      <Item
                                        name={[baseName, 'oversellingQuota']}
                                        rules={[
                                          {
                                            validator: async (x, value) => {
                                              if (!isInteger(value)) {
                                                return Promise.reject(
                                                  new Error(
                                                    getI18n(
                                                      'allProducts.addproductset.stock_component_fill_validvalue',
                                                    ),
                                                  ),
                                                );
                                              }
                                              if (
                                                isInteger(value) &&
                                                value < 1
                                              ) {
                                                return Promise.reject(
                                                  new Error(
                                                    getI18n(
                                                      'allProducts.addproductset.stock_component_fill_value',
                                                    ),
                                                  ),
                                                );
                                              }
                                            },
                                          },
                                        ]}>
                                        <OriNumberInput
                                          disabled={disabled}
                                          //onChange={v}
                                          size='large'
                                          //precision={0}
                                        />
                                      </Item>
                                    </ItemWrapper>
                                  ),
                                },
                                { child: <React.Fragment /> },
                              ]}
                            />
                          );
                        }
                        return null;
                      }}
                    </Item>

                    <React.Fragment>
                      <div className={css.tableTip}>
                        {getI18n(
                          'allProducts.addproductset.stock_component_assign_available',
                        )}
                      </div>
                    </React.Fragment>

                    <Item
                      noStyle
                      shouldUpdate={(p, c) => {
                        const pV = get(p, [
                          warehousePartBaseName,
                          index,
                          'oversellingQuota',
                        ]);
                        const cV = get(c, [
                          warehousePartBaseName,
                          index,
                          'oversellingQuota',
                        ]);
                        const pQ = get(p, quantityFeatureName);
                        const cQ = get(c, quantityFeatureName);
                        const pO = get(p, oversellingQuotaName);
                        const cO = get(c, oversellingQuotaName);

                        return pV !== cV || pQ !== cQ || cO !== pO;
                      }}>
                      {({ getFieldValue }: any) => {
                        const overSellingQuotaAmount =
                          getFieldValue([
                            warehousePartBaseName,
                            index,
                            'oversellingQuota',
                          ]) || 0;
                        const overSellingQuota =
                          getFieldValue(oversellingQuotaName);

                        const quantityFeature =
                          getFieldValue(quantityFeatureName);

                        // const data = form.getFieldValue(
                        //   warehousePartBaseName,
                        //   index,
                        //   'salesChannelItems',
                        // );
                        //console.log(data);
                        const _isValid = (value) => {
                          const total = value.reduce((pre, now) => {
                            const { availableQuantity } = now;
                            return pre + availableQuantity || 0;
                          }, 0);
                          const isValid = () => {
                            if (overSellingQuota) {
                              return (
                                overSellingQuotaAmount +
                                  warehouseStock -
                                  total >=
                                0
                              );
                            } else {
                              return warehouseStock - total >= 0;
                            }
                          };
                          return isValid();
                        };

                        // console.log(data);
                        setTimeout(() => {
                          form.validateFields([
                            [warehousePartBaseName, index, 'salesChannelItems'],
                          ]);
                        });
                        const errorText = getI18n(
                          'allProducts.addproductset.stock_component_errortext',
                        );
                        // setTimeout(() => {
                        //   if (_isValid(data)) {
                        //     form.setFields([{ name: tableName, errors: [] }]);
                        //   } else {
                        //     form.setFields([
                        //       { name: tableName, errors: [errorText] },
                        //     ]);
                        //   }
                        // });

                        if (quantityFeature) {
                          return (
                            <React.Fragment>
                              {/* <button
                        //ref={(x) => (ref.current = x)}
                        onClick={() => {
                          form.validateFields(tableName);
                        }}>
                        123
                      </button> */}
                              <Item
                                className={css.tableFormItem}
                                name={tableName}
                                rules={[
                                  {
                                    validator: async (x, value) => {
                                      if (!_isValid(value)) {
                                        return Promise.reject(
                                          new Error(errorText),
                                        );
                                      }
                                    },
                                  },
                                ]}>
                                <StockTable
                                  disabled={disabled}
                                  warehouseStock={warehouseStock}
                                  overSellingQuotaAmount={
                                    overSellingQuotaAmount
                                  }
                                  overSellingQuota={overSellingQuota}
                                  quantityFeature={quantityFeature}
                                />
                              </Item>
                            </React.Fragment>
                          );
                        } else {
                          const res =
                            warehouseStock +
                            (overSellingQuota ? overSellingQuotaAmount : 0);

                          return (
                            <div className={css.noTableContainer}>
                              <div className={css.noTableItemContainer}>
                                <ItemWrapper
                                  title={getI18n(
                                    'allProducts.addproductset.warehouseStock',
                                  )}>
                                  {warehouseStock.toString() || '0'}
                                </ItemWrapper>
                              </div>
                              <div className={css.noTableItemContainer}>
                                <ItemWrapper
                                  title={getI18n(
                                    'allProducts.addproductset.availableForSale',
                                  )}>
                                  {res > 0 ? res : '0'}
                                </ItemWrapper>
                              </div>
                            </div>
                          );
                        }
                      }}
                    </Item>
                  </Section>
                );
              })}
            </React.Fragment>
          );
        }}
      </List>
    </SectionWrapper>
  );
};
export default Stock;

const StockTable = (props) => {
  const i18n = useI18n();
  const getI18n = (str) => i18nGet(i18n, str);
  const {
    value,
    onChange,
    id,
    warehouseStock,
    overSellingQuotaAmount: _overSellingQuotaAmount,
    overSellingQuota,
    disabled,
  } = props;
  const overSellingQuotaAmount = overSellingQuota
    ? _overSellingQuotaAmount || 0
    : 0;

  const [stock, setStock] = React.useState(value || []);
  React.useEffect(() => {
    if (!isEqual(stock, value)) {
      setStock(value || []);
    }
  }, [value]);
  const handleOnChange = (index, number) => {
    const _stock = [...stock];
    _stock[index]['availableQuantity'] = number;
    onChange(_stock);
    setStock(_stock);
  };

  //console.log(value);
  const len = (stock || []).length;
  const total = stock.reduce((pre, now) => {
    const { availableQuantity } = now;
    return pre + availableQuantity || 0;
  }, 0);
  //console.log(len);
  const col = () => {
    return [
      {
        title: getI18n('general.warehouse'),
        minWidth: 640,
        default: true,
        children: [
          {
            title: getI18n('allProducts.addproductset.warehouseStock'),
            width: 128,
            key: 'warehouseStock',

            render: (_, record, index) => {
              if (index !== 0) {
                return {
                  children: warehouseStock,
                  props: {
                    rowSpan: 0,
                  },
                };
              }
              return {
                children: warehouseStock,
                props: {
                  rowSpan: len,
                },
              };
            },
          },
          ...(overSellingQuota
            ? [
                {
                  title: getI18n('allProducts.addproductset.oversellingQuota'),
                  width: 128,
                  key: 'OversellingQuota',
                  render: (_, record, index) => {
                    if (index !== 0) {
                      return {
                        children: overSellingQuotaAmount.toString(),
                        props: {
                          rowSpan: 0,
                        },
                      };
                    }
                    return {
                      children: <div>{overSellingQuotaAmount.toString()}</div>,
                      props: {
                        rowSpan: len,
                      },
                    };
                  },
                },
              ]
            : []),
          ,
          {
            title: getI18n(
              'allProducts.addproductset.stock_component_total_availableforsale',
            ),
            width: 180,
            key: 'TotalAvailableForSale',
            render: (_, record, index) => {
              const res = overSellingQuotaAmount + warehouseStock;
              if (index !== 0) {
                return {
                  children: res < 0 ? '0' : res,
                  props: {
                    rowSpan: 0,
                  },
                };
              }
              return {
                children: res < 0 ? '0' : res,
                props: {
                  rowSpan: len,
                },
              };
            },
          },
          {
            title: getI18n(
              'allProducts.addproductset.stock_component_unassigned_available',
            ),
            width: 216,
            key: 'UnassignedAvailableForSale',
            render: (_, record, index) => {
              const res = overSellingQuotaAmount + warehouseStock - total;
              if (index !== 0) {
                return {
                  children: res > 0 ? res : '0',
                  props: {
                    rowSpan: 0,
                  },
                };
              }
              return {
                children: res > 0 ? res : '0',
                props: {
                  rowSpan: len,
                },
              };
            },
          },
        ],
      },
      {
        title: getI18n('general.sider.salesChannel'),
        minWidth: 610,
        default: true,
        children: [
          {
            title: getI18n('allProducts.addproductset.salesChannelName'),
            ellipsis: true,
            width: 256,
            key: 'salesChannelName',
            //className: css.borderLeft,
            render: (_, record) => {
              const { name } = record;

              return (
                <div style={{ maxWidth: 400 }}>
                  <NoWrapContainer>
                    <GlobalTooltip title={name}>{name}</GlobalTooltip>
                  </NoWrapContainer>
                </div>
              );
            },
          },
          {
            title: (
              <span>
                <EditIcon />
                {getI18n(
                  'allProducts.addproductset.stock_component_saleschannel_available',
                )}
              </span>
            ),
            width: 300,
            key: 'Available',
            render: (_, record, index) => {
              const { availableQuantity } = record;
              return (
                <TableNumberInputFormItemSupport
                  disabled={disabled}
                  value={availableQuantity}
                  //error={'asd'}
                  //precision={0}
                  label={availableQuantity}
                  itemProps={{
                    wrapperClassName: css.test,
                    precision: 0,
                    formatter: (str) => {
                      if (str) {
                        const reg = /[^\d]/g;
                        return str.replace(reg, '');
                      } else {
                        return str;
                      }
                    },
                  }}
                  // parser={intLimitNumber}
                  min={0}
                  onChange={(input) => {
                    handleOnChange(index, input);
                  }}
                />
              );
            },
          },
        ],
      },
    ];
  };

  return (
    <SizeFittingTable
      columns={col()}
      id={id}
      rowKey='salesChannelUuid'
      pagination={false}
      dataSource={stock}
      //  scroll={{ y: 560 }}
    />
  );
};
